import vanBeauty from "./index.vue";

/* istanbul ignore next */
vanBeauty.install = function(Vue) {
  Vue.component(vanBeauty.name, vanBeauty);
};

export default vanBeauty;
